import { render } from "./Supporter.vue?vue&type=template&id=72d9a5ec"
import script from "./Supporter.vue?vue&type=script&lang=js"
export * from "./Supporter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__